<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>系统配置</el-breadcrumb-item>
        <el-breadcrumb-item>平台公众号配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="never">
      <div slot="header" class="box-card">
        <span>平台公众号配置 ( 注：微信密钥等在服务器中一次配置)</span>
      </div>
      <div class="form">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form ref="form" :model="form" label-width="200px">
              <el-form-item label="微信二维码">       
                <img :src="form.wxQrStr" width="100" height="100" v-if="form.wxQrStr"/>
                <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  :show-file-list="false"
                  action=""
                  :on-change="selectImg"
                >
                  <el-button type="primary" size="small">选择二维码</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="微信H5地址">
                <el-input v-model="form.wxH5Url"></el-input>
              </el-form-item>
              <el-form-item label="微信服务器地址">
                <el-input v-model="form.wxServerUrl"></el-input>
              </el-form-item>
              <el-form-item label="微信H5授权服务器地址">
                <el-input v-model="form.wxAuthUrl"></el-input>
              </el-form-item>
              <!-- <el-form-item label="开发者ID">
                <el-input v-model="form.appId"></el-input>
              </el-form-item>
              <el-form-item label="开发者密钥">
                <el-input v-model="form.appSecret"></el-input>
              </el-form-item>
              <el-form-item label="通讯令牌">
                <el-input v-model="form.communicationToken"></el-input>
              </el-form-item>
              <el-form-item label="消息加解密密钥">
                <el-input v-model="form.messageEncryptKey"></el-input>
              </el-form-item> -->
              <el-form-item label="玩家留言模板ID">
                <el-input v-model="form.playerLeaveTemplateId"></el-input>
              </el-form-item>
              <el-form-item label="充值提示模板ID">
                <el-input v-model="form.rechargeTipsTemplateId"></el-input>
              </el-form-item>
              <el-form-item label="异地登录提示模板ID">
                <el-input v-model="form.longDistanceLoginTipsId"></el-input>
              </el-form-item>
              <el-form-item label="密保验证码模板ID">
                <el-input v-model="form.securityValidTempId"></el-input>
              </el-form-item>
              	<el-form-item label="解绑微信密保模板ID">
								<el-input v-model="form.unBindTipsTempId"></el-input>
							</el-form-item>
              <el-form-item label="联系客服菜单反馈的信息">
                <el-input v-model="form.contactKfReply"></el-input>
              </el-form-item>
              <el-form-item label="关注自动回复">
                <el-input v-model="form.beConcernedReply"></el-input>
              </el-form-item>
              <el-form-item label="规则列表">
                <div class="guize" v-for="(item, index) in rules" :key="index">
                  <div class="item">关键字：</div>
                  <div class="item">
                    <el-input v-model="item.label"></el-input>
                  </div>
                  <div class="item">回复：</div>
                  <div class="item">
                    <el-input v-model="item.value"></el-input>
                  </div>
                  <div class="item">
                    <el-button type="primary" @click="remove(index)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addRules">新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import mgr from "../../assets/js/securityapi";
import api from "../../assets/js/apiRequestHandler";
export default {
  data() {
    return {
      form: {
        customReply: {},
        wxQrStr:''
      },
      rules: [],
    };
  },
  created() {
    this.getRules();
  },
  methods: {
    selectImg(file, fileList) {
      this.getBase64(file.raw).then((res) => {
        console.log(res);
        this.form.wxQrStr = res
        this.$forceUpdate()
      });
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    async getRules() {
      let header = await mgr();
      api
        .get("/api/ManageSystemSet/GetPlatWeChatConfig", {
          headers: {
            Authorization: "Bearer " + header,
          },
          params: {},
        })
        .then((res) => {
          if (res.status === 200) {
            this.form = res.data;
            if (this.form.customReply) {
              this.setRules();
            }
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    async onSubmit() {
      let header = await mgr();
      if (this.rules.length > 0) {
        for (let i in this.rules) {
          this.form.customReply[this.rules[i].label] = this.rules[i].value;
        }
      }
      api
        .post("/api/ManageSystemSet/AddOrUpdatePlatWeChatConfig", this.form, {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    setRules() {
      for (let i in this.form.customReply) {
        this.rules.push({
          label: i,
          value: this.form.customReply[i],
        });
      }
    },
    addRules() {
      let length = this.rules.length + 1;
      this.rules.push({
        label: "additionalProp" + length,
        value: "",
      });
      this.$forceUpdate();
    },
    remove(index) {
      this.rules.splice(index, 1);
    },
  },
};
</script>
<style></style>
<style scoped>
.guize {
  display: flex;
}

.guize .item {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
